import * as Actions from '../actions/statusBarActions';
import {StatusBarActions} from "../actions/statusBarActions";

export type StatusBarState = {
    isFetching: boolean;
    isUploading: boolean;
    fetchSuccessful: boolean;
    fetchErrorMessage: any;
    fetchCount: number;
    totalFetchCount: number;
    /**
     * True when the upload queue has items older than QUEUE_STALL_THRESHOLD_MS
     * that aren't in active healthy backoff. Drives the StatusBar maroon
     * indicator that tells the user "your changes haven't synced for a while."
     */
    queueStalled: boolean;
}

const initialState: StatusBarState = {
    isFetching: false,
    isUploading: false,
    fetchSuccessful: true,
    fetchErrorMessage: false,
    fetchCount: 0,
    totalFetchCount: 0,
    queueStalled: false,
};

function statusBar(state: StatusBarState = initialState, action: StatusBarActions) {
    const st = {...state};

    switch (action.type) {
        case Actions.UPDATE_FETCHING: {
            st.isFetching = action.isFetching;

            return st;
        }

        case Actions.UPDATE_UPLOADING: {
            st.isUploading = action.isUploading;

            return st;
        }

        case Actions.FETCH_ERROR: {
            st.fetchSuccessful = false;
            st.fetchErrorMessage = action.fetchErrorMessage;

            return st;
        }

        case Actions.FETCH_SUCCESS: {
            st.fetchSuccessful = true;
            st.fetchErrorMessage = null;
            st.fetchCount = action.payload.fetchCount;
            st.totalFetchCount = action.payload.totalFetchCount;
            return st;
        }

        case Actions.UPDATE_QUEUE_STALLED: {
            st.queueStalled = action.queueStalled;
            return st;
        }

        default: {
            return state;
        }
    }
}

export default statusBar;
